

export default function ViewDividerMedium() {

  return (
    <>
    <div className="py-3"></div>
    </>
  )
}